// Portions ISC — Lucide Icons (https://lucide.dev/license). Full notice: @air/design-icons LICENSE.
// GENERATED — do not edit. Re-run `pnpm build:icons` or edit scripts/lib/generateIcons.js.
// Source: lucide-react@1.46.0 — SVG path data inlined at codegen.

import { type IconNode } from "../../../internal/iconNode";

export const iconNode = [
  ["circle", { cx: "12", cy: "16", r: "1" }],
  ["rect", { height: "12", rx: "2", width: "18", x: "3", y: "10" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5" }],
] as const satisfies IconNode;
